import { Account } from 'app/api/@generated/backend';

import { AppDispatch } from 'app/redux/types/types';
import { orderSliceActions } from 'app/pages/order/redux/order-slice';

import { resetOrderStateForNewAccountActionCreator } from './reset-order-state-for-new-account-action-creator';

export const selectAccountActionCreator = (selectedAccount: Account) => (dispatch: AppDispatch) => {
    dispatch(resetOrderStateForNewAccountActionCreator());
    dispatch(orderSliceActions.selectAccount(selectedAccount));
};
